import { Injectable } from '@angular/core';
import {
  AngularFireDatabase,
  AngularFireObject,
  AngularFireList,
  DatabaseReference,
} from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../config/Constants';
import { UtilityService } from './utility.service';
import { EventBasicInfo } from '../models/event-basic-info';
import { EventVersion } from '../models/event-version';
import { firebase } from '@firebase/app';
import { from } from 'rxjs/observable/from';
import { EventPreferences } from '../models/event-preferences';
import { MenuTypeService } from './menu-type.service';
import { NodeService } from '../../core/services/nodeservice';
import { ContentsMandatory } from '../models/contents-mandatory';
import { Content } from '../models/content';
import { element } from 'protractor';
import { basename } from 'path';
@Injectable()
export class EventsService {
  menuTypeFileNameList: Array<any> = new Array();
  contentFileNameList: Array<any> = new Array();
  eventId: string = '';
  constructor(
    private db: AngularFireDatabase,
    private utilityService: UtilityService,
    private menuTypyService: MenuTypeService
  ) {}

  getEventList(): AngularFireList<string> {
    if (this.utilityService.isLogged()) {
      return this.db.list(
        Constants.EVENT_LIST_URL + '/' + this.utilityService.getUserUID()
      );
    }
    return null;
  }

  getSharedEventList(): AngularFireList<string>{
    if(this.utilityService.isLogged()){
      const dbNodeUrl = `${Constants.EVENT_EDITOR_LIST_URL}/${this.utilityService.getUserUID()}/events`
      console.log({dbNodeUrl})
      return this.db.list(dbNodeUrl)
    }
    return null
  }

  getEventBasicInfo(eventId): Observable<EventBasicInfo> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<EventBasicInfo> = this.db.object(
        Constants.EVENT_URL + '/' + eventId + Constants.EVENT_BASIC_INFO
      );
      return data.valueChanges();
    }
    return null;
  }

  checkUniqueIdExist(): Promise<any> {
    return firebase.database().ref(Constants.EVENT_ALIAS_URL).once('value');
  }

  createNewEvent(uniqueId): any {
    return this.db.list(Constants.EVENT_URL).push({ aliasId: uniqueId }).key;
  }

  deleteEvent(event: EventBasicInfo, index) {
    this.db.list(Constants.EVENT_ALIAS_URL).remove(event.aliasId);

    this.db.list(Constants.EVENT_USER_DATA_URL).remove(event.eventId);

    this.db.list(Constants.EVENT_APP_URL).remove(event.eventId);

    return this.db.list(Constants.EVENT_URL).remove(event.eventId);
  }

  // this will fetch unique key in advance
  addBasicInfo(basicInfoModel: EventBasicInfo, autoGeneratedKey): any {
    this.db
      .object(Constants.EVENT_URL + '/' + autoGeneratedKey)
      .update({ ['createdAt']: new Date().getTime() });
    this.db
      .object(
        Constants.EVENT_URL +
          '/' +
          autoGeneratedKey +
          Constants.EVENT_BASIC_INFO
      )
      .set(basicInfoModel);
    this.addOwner(this.utilityService.getUserEmail(), autoGeneratedKey);
    this.addVersion(autoGeneratedKey);
    this.addPreferencesDetails(autoGeneratedKey, new EventPreferences());

    this.db
      .object(Constants.EVENT_ALIAS_URL)
      .update({ [basicInfoModel.aliasId]: autoGeneratedKey });
  }
  addOwner(email: string, eventId: string) {
    console.log('owner');
    this.db
      .object(Constants.EVENT_URL + '/' + eventId + Constants.EVENT_OWNER)
      .update({ [0]: email });
  }
  addVersion(eventId: string) {
    console.log('version');
    this.db
      .object(Constants.EVENT_URL + '/' + eventId + Constants.EVENT_VERSION)
      .set(new EventVersion());
  }

  addPreferencesDetails(eventID: string, pref: EventPreferences): any {
    let pre = new EventPreferences();
    if (pref.custom_logo && !pref.custom_logo.custom_logo_id) {
      pref.custom_logo.custom_logo_id = null;
    }
    if (pref.custom_logo && pref.custom_logo.custom_logo_id) {
      pre.custom_logo.custom_logo_id = pref.custom_logo.custom_logo_id;
    }

    /*if (pref.custom_logo && !pref.custom_logo.custom_logo_type) {
      pref.custom_logo.custom_logo_type = null;
    } if (pref.custom_logo && pref.custom_logo.custom_logo_type) {
      pre.custom_logo.custom_logo_type = pref.custom_logo.custom_logo_type;
    }*/

    if (pref.custom_logo && !pref.custom_logo.has_custom_logo) {
      pref.custom_logo.has_custom_logo = null;
    }
    if (pref.custom_logo && pref.custom_logo.has_custom_logo) {
      pre.custom_logo.has_custom_logo = pref.custom_logo.has_custom_logo;
    }
    if (pref.custom_logo && !pref.custom_logo.custom_logo_tint_color) {
      pref.custom_logo.custom_logo_tint_color = null;
    }
    if (pref.custom_logo && pref.custom_logo.custom_logo_tint_color) {
      pre.custom_logo.custom_logo_tint_color =
        pref.custom_logo.custom_logo_tint_color;
    }
    if (pref.custom_logo && pref.custom_logo.custom_logo_has_tint) {
      pre.custom_logo.custom_logo_has_tint =
        pref.custom_logo.custom_logo_has_tint;
    }
    if (pref.custom_logo && pref.custom_logo.widthIos) {
      pre.custom_logo.widthIos = parseInt(pref.custom_logo.widthIos.toString());
    }
    if (pref.custom_logo && pref.custom_logo.has_custom_logo_on_every_page) {
      pre.custom_logo.has_custom_logo_on_every_page =
        pref.custom_logo.has_custom_logo_on_every_page;
    }

    pre.menu.menu_bg_image_id = pref.menu.menu_bg_image_id;
    pre.menu.menu_bg_image_type = pref.menu.menu_bg_image_type;
    pre.menu.menu_has_custom_bg = pref.menu.menu_has_custom_bg;
    pre.menu.menu_has_header = pref.menu.menu_has_header;
    pre.menu.menu_header_type = pref.menu.menu_header_type;
    pre.menu.menu_youtube_url = pref.menu.menu_youtube_url;
    pre.menu.menu_bg_type = pref.menu.menu_bg_type;

    pre.menu.menu_bg_color = pref.menu.menu_bg_color;

    pre.menu.menu_icon_card_color = pref.menu.menu_icon_card_color;
    pre.menu.has_custom_card_color = pref.menu.has_custom_card_color;
    pre.menu.menu_icon_remove_card = pref.menu.menu_icon_remove_card;

    pre.menu.menu_icon_color = pref.menu.menu_icon_color;
    pre.menu.has_custom_icon_color = pref.menu.has_custom_icon_color;

    pre.menu.menu_icon_text_color = pref.menu.menu_icon_text_color;
    pre.menu.has_custom_icon_text_color = pref.menu.has_custom_icon_text_color;

    pre.menu.menu_bg_image_has_blur = pref.menu.menu_bg_image_has_blur;
    pre.menu.menu_bg_image_blur_index = pref.menu.menu_bg_image_blur_index;

    pre.menu.menu_type = pref.menu.menu_type;

    pre.menu.menu_content_mandatory_list =
      pref.menu.menu_content_mandatory_list;
    pre.menu.menuIconType = pref.menu.menuIconType;

    pre.venue = pref.venue;
    pre.splash_map = pref.splash_map;
    pre.listing = pref.listing;
    pre.theme = pref.theme;
    pre.hideImage = pref.hideImage;
    pre.disableFeatures = pref.disableFeatures;
    pre.disclaimer = pref.disclaimer;

    pre = JSON.parse(JSON.stringify(pre));

    console.log({ pref, pre });
    // if(pre?.custom_logo?.widthIos) pre.custom_logo.widthIos = parseInt(pre.custom_logo.widthIos.toString())
    this.db
      .object(Constants.EVENT_URL + '/' + eventID + Constants.PREDERENCES_URL)
      .set(pre);
  }

  updateBasicInfo(basicInfoModel: EventBasicInfo): any {
    this.db
      .object(
        Constants.EVENT_URL +
          '/' +
          basicInfoModel.eventId +
          Constants.EVENT_BASIC_INFO
      )
      .set(basicInfoModel);
  }

  addEventToEventList(eventId: string, eventIdList: string[]) {
    if (this.utilityService.isLogged()) {
      this.db
        .object(
          Constants.EVENT_LIST_URL + '/' + this.utilityService.getUserUID()
        )
        .set(eventIdList);
      console.log('addEventToEventList');
    }
  }

  removeEventToEventList(eventIdList: Array<string>) {
    if (this.utilityService.isLogged()) {
      this.db
        .object(
          Constants.EVENT_LIST_URL + '/' + this.utilityService.getUserUID()
        )
        .set(eventIdList);
    }
  }

  async getEventEditors(eventId: string) {
    const dbPath = `${Constants.EVENT_EDITOR_LIST_URL}`;

    const snapshot = await firebase.database().ref(dbPath).once('value');
    const eventUsers = snapshot.val();
    const eventEditors = [];

    for (const [firebaseUid, value] of Object.entries(eventUsers)) {
      if (value['events'].includes(eventId)) {
        eventEditors.push({
          email: value['email'],
          uid: firebaseUid,
        });
      }
    }

    console.log({ eventEditors });
    return eventEditors
  }

  addEventEditor(eventId: string, firebaseUid:string, userEmail: string) {
    const dbPath =
      Constants.EVENT_EDITOR_LIST_URL + '/' + firebaseUid;
      
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(dbPath)
        .once('value')
        .then(snapshot => {
          const userData = snapshot.val();
          if (userData) {
            const events = userData.events;
            events.push(eventId);
            this.db.object(dbPath).set({
              events: events.filter((v, i, a) => a.indexOf(v) === i),
            });
            resolve({});
          } else {
            this.db.object(dbPath).set({
              email: userEmail,
              events: [eventId],
            });
            resolve({});
          }
        });
    });
  }

  // TODO: Can be improved
  async isEventEditor(eventId: string) {
    const eventEditorsUid = (await this.getEventEditors(eventId)).map(obj => obj.uid)
    const uid = this.utilityService.getUserUID()
    if(eventEditorsUid.includes(uid)) return true
    return false
  }

  /*getEventMenuType(eventId): Observable<ContentsMandatory> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<ContentsMandatory> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.Contents_Mandatory_URL);
      return data.valueChanges();
    }
    return null;
  }

  getEventContent(eventId): Observable<Content> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<Content> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.CONTENT_URL);
      return data.valueChanges();
    }
    return null;
  }

  getSpeakerData(eventId): Observable<Content> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<Content> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPEAKER_URL);
      return data.valueChanges();
    }
    return null;
  }

  getSponsorsData(eventId): Observable<Content> {
    if (this.utilityService.isLogged()) {
      let data: AngularFireObject<Content> = this.db.object(Constants.EVENT_URL + '/' + eventId + Constants.SPONSORS_URL);
      return data.valueChanges();
    }
    return null;
  }*/
}



// WEBPACK FOOTER //
// /app/src/app/core/services/events.service.ts